<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body" ></p-confirmDialog>
<app-cc-form-dialog #batchUpdateFormDialog [transPartKey]="transPartKey"
                    [loading]="formLoading" [submitted]="formSubmitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    (dialogFormVisibleChange)="dialogFormVisibleChanged($event)"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [submitButtonLabel]="'page.'+transPartKey+'.dialog.batch-update'|translate"
                    [loadingProgressValue]="settingsFormLoadingProgressValue"
                    [globalInfoMessage]="globalInfoMessage"
></app-cc-form-dialog>

